<template>
    <div>
        <v-form ref="form" v-model="valid" @submit.prevent>
                <span class="input-level"><i class="far fa-fw fa-star text-danger"></i> Mobile Number:</span>
                <v-text-field
                        v-model="mobile_number"
                        outlined
                        dense
                        :rules="[ v => !!v || 'Mobile Number is required', v => (v && v.length === 11)  || 'Phone number must be 11 digits',]"
                        required
                ></v-text-field>
            <div id="mobile-verify" v-if="otpSent">
                    <span class="input-level"><i class="far fa-fw fa-star text-danger"></i> OTP Code:</span>
                    <v-text-field
                            v-model="otp"
                            dense
                            outlined
                            :rules="[ v => !!v || 'OTP is required', v => (v && v.length == 6)  || 'OTP must be 6 digits',]"
                            required
                    ></v-text-field>
            </div>
            <div class="row">
                <div class="col-md-4 offset-md-4">
                    <!-- reCAPTCHA container -->
                    <div id="recaptcha-container"></div>
                    <button type="button" class="btn btn-primary rounded-pill btn-block" v-if="!otpSent" :disabled="!valid" @click="submitMobile">
                        Send OTP
                    </button>
                    <button type="button" class="btn btn-primary rounded-pill btn-block" v-else :disabled="!valid" @click="loginWithOtp">
                        Verify OTP
                    </button>
                </div>
            </div>
        </v-form>
    </div>
</template>

<script>
    import authService from "@/core/services/auth/auth.service";
    import store from "@/core/services/store";
    import {ACTION_SET_TOKEN} from "@/core/services/store/authentication.module";

    export default {
        name: "LoginWithOtp",
        data(){
            return {
                valid : false,
                mobile_number: null,
                otp: null,
                otpSent : false,
                otpToken : null,
                recaptchaWidgetId: null,
                recaptchaReady: false,
            }
        },
        mounted() {
          this.waitForRecaptcha()
        },
        methods : {
            loginWithOtp(e){
                // console.log(this.$route); return;
                e.preventDefault();
                authService.loginWithOtp({
                    mobile_number: this.mobile_number,
                    otp: this.otp
                }, (responseData) => {
                    store.dispatch(ACTION_SET_TOKEN,responseData).then(()=>{
                            this.$router.push({path:"/profile"},()=>{
                                this.$toasted.success("Login successful");
                            });
                        }
                    )
                }, error => {
                    this.$toasted.error(error);
                })
            },

            waitForRecaptcha() {
              if (window.grecaptcha && window.grecaptcha.render) {
                this.renderRecaptcha()
              } else {
                setTimeout(this.waitForRecaptcha, 300)
              }
            },
            renderRecaptcha() {
              if (this.recaptchaWidgetId !== null) return
              this.recaptchaWidgetId = grecaptcha.render('recaptcha-container', {
                sitekey: '6LfbaUIsAAAAAODRzE0ukEiOTKNWl9iud8o-hwTM',
                size: 'invisible',
                callback: this.onRecaptchaSuccess,
              })
              this.recaptchaReady = true
            },
            submitMobile() {
              if (!this.recaptchaReady) {
                console.error('reCAPTCHA not ready')
                return
              }
              grecaptcha.execute(this.recaptchaWidgetId)
            },
            onRecaptchaSuccess(token) {
              this.sendOtp(token)
            },
            sendOtp(recaptchaToken){
                this.otpSent = true;
                this.otpTokenGenerate().then(hash => {
                  this.otpToken = hash;
                  authService.requestForOtp({mobile_number:this.mobile_number, otp_token:this.otpToken, recaptcha_token: recaptchaToken},(data)=>{
                    this.otpSent = true;
                    this.$toasted.success(data.message);
                  },(error)=>{
                    if(error.includes("Recently an OTP has been sent")){
                      this.otpSent = true;
                      this.$toasted.success(error);
                    }else{
                      this.otpSent = false;
                      this.$toasted.error(error);
                    }
                  })
                });
            },
            async otpTokenGenerate() {
                const now = new Date();
                let code = "chkjan" +
                    String(now.getUTCHours()).padStart(2, '0') +
                    String(now.getUTCMonth() + 1).padStart(2, '0') +
                    now.getUTCFullYear() +
                    String(now.getUTCDate()).padStart(2, '0');
                //console.log(code);
                const encoder = new TextEncoder();
                const data = encoder.encode(code);
                const hashBuffer = await crypto.subtle.digest('SHA-256', data);
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
                //console.log(hashHex);
                return hashHex;
            }
        },
        beforeDestroy() {
          // important for SPA route/component switching
          this.recaptchaWidgetId = null
        }
    }
</script>

<style scoped>

</style>
